'use client'
import { useUserStore } from "@/store/useUserStore"
import dynamic from "next/dynamic"
import { useEffect, useState } from "react"

// 弹窗与动画只在需要展示时才加载，不进首屏 bundle
const FeatureIntroModal = dynamic(() => import("./FeatureIntroModal"), { ssr: false })

// 换一个 key 即可让所有用户重新看一遍
const SEEN_KEY = "hw-feature-intro-lorebook-moment"
// URL 带 ?feature_intro 时无视已读强制展示，便于测试和运营外链
const FORCE_PARAM = "feature_intro"

// 其它弹窗/横幅开着，或用户正在输入时顺延，避免叠弹和打断
const isBusy = () => {
  if (document.querySelector('[role="dialog"]')) return true
  const el = document.activeElement
  if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) return !!el.value
  return el instanceof HTMLElement && el.isContentEditable && !!el.textContent
}

/** 已登录用户首次进入时自动弹出一次 Lorebook / 情景 新功能介绍 */
export const FeatureIntro = () => {
  const isLogined = useUserStore(state => state.isLogined)
  const isPending = useUserStore(state => state.isPending)
  const [status, setStatus] = useState<"idle" | "open" | "closed">("idle")

  useEffect(() => {
    if (status !== "idle" || isPending) return
    const forced = new URLSearchParams(window.location.search).has(FORCE_PARAM)
    if (!forced && (!isLogined || localStorage.getItem(SEEN_KEY))) return

    let timer: ReturnType<typeof setTimeout>
    const tryOpen = () => {
      if (isBusy()) {
        timer = setTimeout(tryOpen, 3000)
        return
      }
      localStorage.setItem(SEEN_KEY, "1")
      setStatus("open")
    }
    timer = setTimeout(tryOpen, 1500)
    return () => clearTimeout(timer)
  }, [isLogined, isPending, status])

  if (status === "idle") return null
  return <FeatureIntroModal isOpen={status === "open"} onClose={() => setStatus("closed")} />
}
